/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

const ImgComponent = React.forwardRef(
  (
    {
      block, // eslint-disable-line no-unused-vars
      blockProps, // eslint-disable-line no-unused-vars
      customStyleMap, // eslint-disable-line no-unused-vars
      customStyleFn, // eslint-disable-line no-unused-vars
      decorator, // eslint-disable-line no-unused-vars
      forceSelection, // eslint-disable-line no-unused-vars
      offsetKey, // eslint-disable-line no-unused-vars
      selection, // eslint-disable-line no-unused-vars
      tree, // eslint-disable-line no-unused-vars
      contentState, // eslint-disable-line no-unused-vars
      blockStyleFn, // eslint-disable-line no-unused-vars
      preventScroll, // eslint-disable-line no-unused-vars
      style,
      ...elementProps
    },
    ref,
  ) => (
    <div style={{ width: `${blockProps.width}%` }} className="min-width">
      <img ref={ref} src={blockProps.src} {...elementProps} style={{ height: '100%', width: '100%' }} alt="" />
    </div>

  ),
);
ImgComponent.displayName = 'ImgComponent';

export default ImgComponent;
